// install (please make sure versions match peerDependencies)
// yarn add @nivo/core @nivo/pie
import {Pie } from '@nivo/pie'
import React from 'react'
import PropTypes from 'prop-types'
import defaultData from './data'
// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.


const CenteredMetric = ({dataWithArc , centerX, centerY,  }) => {

        const updatedArc = dataWithArc.find(data => data.id === 'updated')
        const value = updatedArc ? updatedArc.value : 0

         return  (
         <text
           x={centerX}
           y={centerY}
           textAnchor="middle"
          >
            <tspan fontSize={19} style={{lineHeight: '24px', color: '#4D4D4D'}} fontWeight={600}  x={centerX} y={centerY - 20} dy="1em"> {value}% </tspan>
            <tspan fontSize={14} style={{lineHeight: '17px', color: '#4D4D4D'}}  x={centerX} y={centerY + 1} dy="1em">Atualizado</tspan>
          </text>
         )
}

CenteredMetric.propTypes = {
  dataWithArc: PropTypes.array,
  centerX: PropTypes.number,
  centerY: PropTypes.number
}


const MyResponsivePie = ({data = defaultData, height = 250, width=200}) => <Pie
        width={width}
        height={height}
        data={data}
        layers={['arcs', 'arcLabels', 'arcLinkLabels', 'legends', CenteredMetric]}
        colors={{datum: 'data.color'}}
        startAngle={-185}
        innerRadius={0.75}
        fit={false}
        isInteractive={false}
        sortByValue={false}
        activeOuterRadiusOffset={2}
        borderWidth={0.1}
        enableArcLinkLabels={false}
        arcLinkLabel={function(e){return `${e.id} (${e.value})`}}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsStraightLength={21}
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        enableArcLabels={false}
        arcLabelsRadiusOffset={0.3}
        arcLabelsSkipAngle={11}
        motionConfig="slow"
        transitionMode="startAngle"
        defs={[

            {
                id: 'lines',
                type: 'patternLines',
                background: 'inherit',
                color: 'rgba(255, 255, 255, 0)',
                rotation: -45,
                lineWidth: 6,
                spacing: 1
            }
        ]}
        fill={[
            {
                match: {
                    id: 'updated'
                },
                id: 'lines'
            },
            {
                match: {
                    id: 'notUpdated'
                },
                id: 'lines'
            },

            {
              match: {
                id: "empty"
              },
              id: "lines"
            }


        ]}



    />

MyResponsivePie.propTypes = {
  data: PropTypes.object.isRequired,
  height: PropTypes.number,
  width: PropTypes.number
}

export default MyResponsivePie
